import { useEffect, useState } from "react";
import { Check } from "lucide-react";
import { useCreateOrder } from "./create-order-context";
import { useTranslation } from "react-i18next";

function formatRelative(
  savedAt: number,
  now: number,
  t: (key: string, options?: Record<string, number>) => string
): string {
  const seconds = Math.max(0, Math.floor((now - savedAt) / 1000));
  if (seconds < 5) return t("createShipment.justNow");
  if (seconds < 60) return t("createShipment.secondsAgo", { count: seconds });
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return t("createShipment.minutesAgo", { count: minutes });
  const hours = Math.floor(minutes / 60);
  return t("createShipment.hoursAgo", { count: hours });
}

export function DraftSavedIndicator() {
  const { t } = useTranslation("app");
  const { lastSavedAt, data } = useCreateOrder();
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!lastSavedAt) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [lastSavedAt]);

  if (!lastSavedAt || Object.keys(data).length === 0) {
    return (
      <span className="text-sm text-default-500">
        {t("createShipment.draftsAutoSave")}
      </span>
    );
  }

  return (
    <span className="text-sm text-default-500 inline-flex items-center gap-1.5">
      <Check className="h-3.5 w-3.5 text-success" />
      {t("createShipment.savedRelative", {
        time: formatRelative(lastSavedAt, now, t),
      })}
    </span>
  );
}
